import { render, staticRenderFns } from "./BaseBoxTitle.vue?vue&type=template&id=b7b74204&scoped=true"
import script from "./BaseBoxTitle.vue?vue&type=script&lang=js"
export * from "./BaseBoxTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7b74204",
  null
  
)

export default component.exports